import { useEffect, useState } from "react";
import { resolver } from "../../../API/middlewares/resolveRequests";
import {
  procData,
  updateProcStatus,
} from "../../../API/store/actions/procedure/procedure";
import { getAllTaskStatus } from "../../../API/store/actions/tasks";
import Bullets from "../../sharedComponents/bullets/bullets";

const EditProcStatus = ({ userToken, procId, procAdded, setProcAdded }) => {
  const [status, setStatus] = useState(null);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [proc, setProc] = useState(null);

  useEffect(() => {
    setStatus(null);
    resolver(getAllTaskStatus, setStatus, userToken);
    resolver(procData, setProc, procId, userToken);
  }, []);

  useEffect(() => {
    if (currentStatus) {
      updateProcStatus(procId, currentStatus, userToken);
    }
  }, [currentStatus]);

  //   useEffect(() => {
  //     if (currentStatus) resolver(procData, setProc, procId);
  //   }, [currentStatus]);

  if (status && procData)
    return (
      <div className="d-flex flex-lg-row flex-column justify-content-between mx-3">
        <div style={{ fontSize: 18 }} className="col-lg-9 col-12">
          {proc?.data?.description}
        </div>
        <div className="d-flex align-items-center justify-content-center col-lg-3 mt-lg-0 col-12 mt-4">
          {status?.data?.taskStatusLkp.map((item, index) => {
            return (
              <div className=" d-flex flex-column justify-content-center align-items-center mx-2">
                <Bullets
                  key={index}
                  containerStyle={{ width: 21 }}
                  memberId={proc?.data?.id}
                  id={item.id}
                  borderColor={"#1a73e8"}
                  bulletColor={item?.color}
                  tooltipTitle={item.name}
                  setActive={setCurrentStatus}
                  procAdded={procAdded}
                  setProcAdded={setProcAdded}
                  active={currentStatus ?? proc?.data?.taskStatusId}
                />

                <div className=" text-center">{item.name} </div>
              </div>
            );
            //   procStatus ??
          })}
        </div>
      </div>
    );
  return <div></div>;
};
export default EditProcStatus;
